import { successMessage } from "@constants/errSuccConstant";

const today = new Date();

export const sickChildCareData: any = {
    diarrheaTreatment: {
        '#type': 'select',
        '#title': 'Diarrhea Treatment',
        '#webform_key': 'diarrheaTreatment',
        '#options': [],
        '#required': true
    },
    havingPneumonia: {
        '#type': 'select',
        '#title': 'Is the Child having Pneumonia (fever and fast breathing/ chest- in drawing)',
        '#webform_key': 'havingPneumonia',
        '#options': [],
        '#required': false
    },
    deathRelatedInformation: {
        '#type': 'select',
        '#title': 'Death related information',
        '#webform_key': 'deathRelatedInformation',
        '#options': [],
        '#required': true
    },
};

export const sickChildCareDataInitialValues: any = {
    deathRelatedInformation: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id:''

    },
    diarrheaTreatment: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id:''

    },
    havingPneumonia: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id:''
    },
}

export const DeathDetailsData: any = {
    deathHappenedDueTo: {
        '#type': 'select',
        '#title': 'Death happened due to',
        '#webform_key': 'deathHappenedDueTo',
        '#required': true,
        '#options': []
    },
    date_of_death: {
        '#type': 'date',
        '#title': 'Date of Death',
        '#webform_key': 'date_of_death',
        '#required': true,
        '#maxDate': today,
    },
    timeOfDeath: {
        '#type': 'time',
        '#title': 'Time Of Death',
        '#webform_key': 'timeOfDeath',
        '#required': true
    },
    probableCauseOfDeath: {
        '#type': 'select',
        '#title': 'Probable Cause of Death',
        '#webform_key': 'probableCauseOfDeath',
        '#required': false,
        '#options': [],
        '#isDisabled': true
    },
    placeOfDeath: {
        '#type': 'select',
        '#title': 'Place Of Death',
        '#webform_key': 'placeOfDeath',
        '#options': [],
        '#required': true
    },
    death_notification_sent_by_asha_with_24hrs: {
        '#type': 'select',
        '#title': 'Notification sent by ASHA within 24 Hrs',
        '#webform_key': 'death_notification_sent_by_asha_with_24hrs',
        '#options': [{
            value: 'Yes',
            label: 'Yes',
            code: 'Yes',
        },
        {
            value: 'No',
            label: 'No',
            code: 'No',
        }],
        '#required': true
    },
    fbir_completed_by_anm: {
        '#type': 'select',
        '#title': 'FBIR Completed by ANM/ MPW?',
        '#webform_key': 'fbir_completed_by_anm',
        '#options': [{
            value: 'Yes',
            label: 'Yes',
            code: 'Yes',
        },
        {
            value: 'No',
            label: 'No',
            code: 'No',
        }],
        '#required': true
    },
};

export const DeathDetailsInitialValues: any = {
    deathHappenedDueTo: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id:''
    },
    date_of_death: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
    },
    timeOfDeath: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
    },
    probableCauseOfDeath: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id:''
    },
    placeOfDeath: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id:''
    },
    death_notification_sent_by_asha_with_24hrs: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id:''
    },
    fbir_completed_by_anm: {
        isError: false,
        message: '',
        isDisable: true,
        value: '',
        id:''
    },
}


export const DeathDetailsDataView: any = {
  death_reason_name: {
    'title': 'Death reason',
    'webform_key': 'death_reason_name',
    'value': ''
  },
  date_of_death: {
    'title': 'Date of Death',
    'webform_key': 'date_of_death',
    'value': ''
  },
  timeOfDeath: {
    'title': 'Time Of Death',
    'webform_key': 'timeOfDeath',
    'value': ''
  },
  probable_cause_of_death_name: {
    'title': 'Probable Cause of Death',
    'webform_key': 'probable_cause_of_death_name',
    'value': ''
  },
  place_of_death_name: {
    'title': 'Place Of Death',
    'webform_key': 'place_of_death_name',
    'value': ''
  },
  death_notification_sent_by_asha_with_24hrs: {
    'title': 'Notification sent by ASHA within 24 Hrs',
    'webform_key': 'death_notification_sent_by_asha_with_24hrs',
    'value': ''
  },
  fbir_completed_by_anm: {
    'title': 'FBIR Completed by ANM/ MPW?',
    'webform_key': 'fbir_completed_by_anm',
    'value': ''
  },
};

export const ServiceReportCodeForChild = {
  diarrheaTreatment: 'diarrhea_treatment',
  havingPneumonia: 'is_the_child_having_pneumonia_fever_and_fast_breathing_chest-_in_drawing',
};

export const COMMON_CONSTANTS = {
    SICK_CHILD_CARE_DETAILS: 'Sick Child Care Details',
    SICK_CHILD_CARE: 'Sick Child Care',
    TITLE: "Add Details/Sick Child Care",
    DEATH_DUE_TO_OTHER_THAN_AEFI:'Death due to other than AEFI',
    successMessage:"Sick Child Care details saved successfully",
    somethingWentWrong:"Something went wrong",
    DECEASED_CONFIRMATION_TITLE: 'Are you sure you want to mark the child as deceased?',
}